export const navTravelMenu = [
  [
    {
      key: 'travel:1',
      url: 'https://travel.aaa.com/vacations/',
      label: 'Member Travel Benefits',
    },
    {
      key: 'travel:2',
      url: 'https://carolinas.aaa.com/travel/triptiks/',
      label: 'Maps, TripTiks & TourBooks',
    },
    {
      key: 'travel:3',
      url: 'https://carolinas.aaa.com/travel/',
      label: 'Air, Car & Hotel Reservations',
    },
    {
      key: 'travel:4',
      url: 'https://www.aaa.com/travelguides/',
      label: 'Destinations',
    },
    {
      key: 'travel:5',
      url: 'https://carolinas.aaa.com/travel/cruises/',
      label: 'Cruises',
    },
    {
      key: 'travel:6',
      url: 'https://carolinas.discounts.aaa.com/deal/overview?id=Vacations',
      label: 'Vacation Packages',
    },
    {
      key: 'travel:13',
      url: 'https://member.acg.aaa.com/car/travel/travel-with-confidence.html?zip=28205',
      label: 'Travel With Confidence',
    },
  ],
  [
    {
      key: 'travel:7',
      url: 'https://carolinas.discounts.aaa.com/deal/overview?id=Vacations',
      label: 'Travel Deals',
    },
    {
      key: 'travel:8',
      url: 'https://carolinas.aaa.com/travel/theme-parks/',
      label: 'Theme Parks',
    },
    {
      key: 'travel:9',
      url: 'https://carolinas.aaa.com/travel/ideas/',
      label: 'Planning Tips & Resources',
    },
    {
      key: 'travel:10',
      url: 'https://member.acg.aaa.com/car/travel/travel-insurance.html?zip=28205',
      label: 'Travel Insurance',
    },
    {
      key: 'travel:11',
      url: 'https://carolinas.aaa.com/travel/sightseeing/',
      label: 'Sightseeing',
    },
    {
      key: 'travel:12',
      url: 'https://carolinas.aaa.com/travel/business/',
      label: 'Business Travel',
    },
  ],
];

export const navTravelPromo = [
  {
    title: 'Travel with AAA',
    content: 'Save time and money on your next great adventure.',
    img: '',
    buttonText: 'Find a Travel Agent',
    buttonUrl: 'http://locator.carolinas.aaa.com/?type=travel',
  },
];
